import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { useCrm } from "../../pages/crm/CrmApp";
import { money } from "../../lib/crmApi";
import { inputCls, Labeled } from "../market/admin/ui";

export const SaleDialog = ({ open, contact, quotes = [], onClose, onSaved }) => {
  const { api, isOwner } = useCrm();
  const [f, setF] = useState({ amount: "", description: "", quote_id: "", seller_id: "", date: "" });
  const [team, setTeam] = useState([]);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!open) return;
    setErr("");
    setF({ amount: "", description: "", quote_id: "", seller_id: contact?.owner_user_id || "", date: new Date().toISOString().slice(0, 10) });
    if (isOwner) api("/team").then(setTeam);
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  const pickQuote = (id) => {
    const q = quotes.find((x) => x.id === id);
    setF((x) => ({ ...x, quote_id: id, amount: q ? q.total : x.amount, description: q ? `Cotización ${q.number}` : x.description }));
  };
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await api("/sales", { method: "POST", body: { contact_id: contact.id, amount: Number(f.amount), description: f.description, quote_id: f.quote_id || null, seller_id: f.seller_id || null, date: f.date ? new Date(`${f.date}T12:00:00`).toISOString() : null } });
      onSaved?.();
      onClose();
    } catch (e2) {
      setErr(e2.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm rounded-2xl" data-testid="crm-sale-dialog">
        <DialogHeader><DialogTitle>Registrar venta</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-3">
          {quotes.length > 0 && (
            <Labeled label="De una cotización (opcional)">
              <select className={inputCls} value={f.quote_id} onChange={(e) => pickQuote(e.target.value)} data-testid="crm-sale-quote">
                <option value="">—</option>
                {quotes.map((q) => <option key={q.id} value={q.id}>{q.number} · {money(q.total)}</option>)}
              </select>
            </Labeled>
          )}
          <Labeled label="Monto"><input required type="number" min="0.01" step="0.01" className={inputCls} value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} data-testid="crm-sale-amount" /></Labeled>
          <Labeled label="Concepto"><input className={inputCls} value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} data-testid="crm-sale-description" /></Labeled>
          <Labeled label="Fecha"><input type="date" className={inputCls} value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} data-testid="crm-sale-date" /></Labeled>
          {isOwner && team.length > 1 && (
            <Labeled label="Vendedor (para comisión)">
              <select className={inputCls} value={f.seller_id} onChange={(e) => setF({ ...f, seller_id: e.target.value })} data-testid="crm-sale-seller">
                <option value="">Yo (sin comisión)</option>
                {team.filter((t) => t.role !== "owner").map((t) => <option key={t.id} value={t.id}>{t.name} · {t.commission_type === "percent" ? `${t.commission_value}%` : money(t.commission_value)}</option>)}
              </select>
            </Labeled>
          )}
          {err && <p className="text-sm text-red-600">{err}</p>}
          <button disabled={busy} className="flex w-full items-center justify-center gap-2 rounded-xl bg-emerald-600 py-3 text-sm font-semibold text-white" data-testid="crm-sale-save">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Guardar venta
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
